import { cfBus } from "../data/chainStore";
import { toast } from "sonner";
import { api, apiError } from "./api";

const CONTACT_ROLE_FOR = {
  buyer: "Buyer", seller: "Seller", buyer_solicitor: "Solicitor", seller_solicitor: "Solicitor",
  broker: "Mortgage Broker", mortgage_broker: "Mortgage Broker", negotiator: "Estate Agent", agent: "Estate Agent",
  managing_agent: "Managing Agent",
};
const PG_TYPE_FOR = { broker: "mortgage_broker", agent: "negotiator" };

// Open the shared Add Contact modal prefilled from a participant, then link the saved contact to the deal row.
export function createContactForParticipant(dealId, participant) {
  const role = participant?.participant_type || participant?.role || "other";
  cfBus.emit("cf:open-contact", {
    name: participant?.full_name || participant?.name || "",
    email: participant?.email || "",
    phone: participant?.phone || "",
    company: participant?.organisation_name || "",
    role: CONTACT_ROLE_FOR[role] || "Other",
    onSaved: async (row) => {
      try {
      if (participant?.link_participant_id) {
        await api.patch(`/api/v2/deals/${dealId}/participants/${participant.link_participant_id}`, { contact_id: row.id });
      } else {
        await api.post(`/api/v2/deals/${dealId}/participants`, {
          participant_type: PG_TYPE_FOR[role] || role,
          full_name: row.name || participant?.full_name,
          email: row.email || participant?.email || null,
          phone: row.phone || participant?.phone || null,
          contact_id: row.id,
        });
      }
      window.dispatchEvent(new CustomEvent("cf:participants-changed", { detail: { dealId } }));
      } catch (err) {
        toast.error("Contact saved, but not linked to this deal", { description: apiError(err) });
      }
    },
  });
}
